const prod = {
  url: {
    DOMAIN_URL: `https://dedaai.azurewebsites.net`,
    API_URL: `https://dedaai-server.azurewebsites.net`,
  }
};

const dev = {
  url: {
    DOMAIN_URL: 'http://localhost:3000',
    API_URL: `http://localhost:5000`
  }
};

export const config = process.env.NODE_ENV === `production` ? prod : dev;